<template>
  <div class="editCube Msg">
    <div>{{title}}
      <button v-if="!edit" class="editBtn" @click="edit=true"></button>
    </div>
    <div v-if="edit" :style="{display: 'flex', width: '100%'}">
      <button class="template" @click="data=template">範例訊息</button>
      <button :style="{marginLeft: 'auto'}" class="deftext" @click="insertText('{OTP}')">驗證碼</button>
      <button class="deftext" @click="insertText('{預約日期}')">預約日期</button>
      <button class="deftext" @click="insertText('{預約時間}')">預約時間</button>
      <button class="deftext" @click="insertText('{人數}')">人數</button>
      <button class="deftext" @click="insertText('{大人小孩}')">大人小孩</button>
      <button class="deftext" @click="insertText('{匯款金額}')">匯款金額</button>
    </div>
    <p v-if="!edit" v-html="data?(
      data
      .replaceAll('\n', '<br>')
      .replaceAll('{OTP}', '<span>驗證碼</span>')
      .replaceAll('{預約日期}', '<span>預約日期</span>')
      .replaceAll('{預約時間}', '<span>預約時間</span>')
      .replaceAll('{人數}', '<span>人數</span>')
      .replaceAll('{大人小孩}', '<span>大人小孩</span>')
      .replaceAll('{匯款金額}', '<span>匯款金額</span>')
    ):''"
      :style="{color: 'var(--color-letter)', lineHeight: '180%'}"></p>
    <label class="textinput" v-else :for="keyname">
      <textarea :style="{padding: '1em', lineHeight: '180%'}" :ref="keyname" v-model="data" :id="keyname" :disabled="!edit"/>
    </label>
    <div class="btns" v-if="edit">
      <button class="cancel" @click="edit=false">取消</button>
      <button class="confirm" @click="udpateData(keyname, data)">儲存</button>
    </div>
  </div>
</template>

<script>
import { getapi, postapi } from '../store/fetch'
export default {
  props: ['keyname', 'title', 'template'],
  data () {
    return {
      edit: false,
      data: null
    }
  },
  async mounted () {
    this.getdata()
  },
  methods: {
    insertText (Content) {
      try {
        this.$refs[this.keyname].focus()
        var mySelection = document.selection.createRange()
        mySelection.text = Content
        this.data = this.$refs[this.keyname].value
      } catch (error) {
        try {
          var myPrefix = this.$refs[this.keyname].value.substring(0, this.$refs[this.keyname].selectionStart)
          var mySuffix = this.$refs[this.keyname].value.substring(this.$refs[this.keyname].selectionEnd)
          this.data = myPrefix + Content + mySuffix
        } catch (error) {
          console.log(error)
        }
      }
    },
    async getdata () {
      this.data = await getapi(`selections/${this.keyname}`)
    },
    async udpateData () {
      this.data = await postapi(`selections/${this.keyname}`, { key: 'value', data: this.data })
      this.edit = false
    }
  }
}
</script>
<style lang="scss">
.editCube.Msg {

  span {
    display: inline;
    padding: 4px 6px;
    color: #FFFFFF;
    width: fit-content;
    height: fit-content;
    background-color: var(--color-checked);
    font-size: 18px;
    color: #FFFFFF;
    border-radius: 3px;
    margin-inline: 3px;
  }
}
</style>
<style lang="scss" scoped>
button.template {
width: 90px;
height: 35px;
background: var(--color-bar);
border: 1px solid var(--color-checked);
border-radius: 3px;
color: var(--color-checked);
font-size: 14px;
line-height: 20px;
letter-spacing: 0.1em;
}
button.keytemp {
width: 90px;
height: 35px;
background: var(--color-bar);
border: 1px solid var(--color-checked);
border-radius: 3px;
color: var(--color-checked);
margin-left: 10px;
font-size: 14px;
line-height: 20px;
letter-spacing: 0.1em;
}
.deftext {
  margin-left: 10px;
  height: 35px;
  background: var(--color-bar);
  border: 1px solid var(--color-checked);
  border-radius: 3px;
  color: var(--color-checked);
  margin-left: 10px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1em;
  padding-inline: .5em;
}
p {
  text-align: start;
  vertical-align: middle;

}
.textinput {
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 100%;
  z-index: 1;
  border: 1px solid #CACACA;
  &>textarea {
    position: relative;
    color: transparent;
    z-index: 3;
    min-height: 100px;
    background-color: transparent;
    color: var(--color-letter);
  }
  &>p {
    position: relative;
    border: 1px solid var(--color-border);
    color: var(--color-letter);
    z-index: 2;
  }
}
.editCube {
  margin: 0;
  margin-bottom: 20px;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 9px;
  textarea, p {
    margin: 0;
    padding: 7px 20px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0.1em;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
  }
  &>div:nth-child(1) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button.editBtn {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(/pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}

</style>
